module.exports = " <div class=page-sidebar-wrapper _v-27775994=\"\"> <div id=menuprincipal class=\"page-sidebar navbar-collapse collapse\" _v-27775994=\"\"> <cpmenu _v-27775994=\"\"></cpmenu> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-27775994!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/sidebarmenu/menu.vue
// module id = 206
// module chunks = 0